import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ProfileChange } from './subcomponents/ProfileChange'
import { SlPageTitle, SlButton, SlBusyIndicator } from './editors'
import { history } from "../_helpers"
import { ViewProfile, EditProfileInfo } from './subcomponents';
import { profileActions } from '../_actions/profile.actions';
import { MfaValidation } from './subcomponents/MfaValidation';
import { AccountAPI, metadataService, SessionService } from '../_services';
import validator from "validator";
import { financialInfoActions } from '../_actions/financial.actions';
import { FinancialInfo } from './subcomponents/FinancialInfo';
import { userService ,FinancialService} from '../_services';
import { userActions } from '../_actions';
import { scrollToTop } from '../utils/scrollToTop';


class MyProfile extends Component {
    //static displayName = MyProfile.name;

    constructor(props) {
        super(props);
        this.STATE_VIEW= 0; 
        this.STATE_EDIT_ADDRESS=1; 
        this.STATE_MFA_CONFIRM=2; 
        this.STATE_VALIDATE_MOBILE=3; 
        this.STATE_PROFILE_SAVED = 4;   
        this.STATE_EDIT_FINANCIAL_INFO = 5;
        this.state = {
          isLoading: false, 
          formState: this.STATE_VIEW,
          canGoBack: false, 
          canGoNext: true
        };

        this.handleRequestEditProfile = this.handleRequestEditProfile.bind(this);
        this.handleRequestEditFinancialInfo = this.handleRequestEditFinancialInfo.bind(this);
        this.handleChangeProfile = this.handleChangeProfile.bind(this);
        this.handleChangeFinancialInfo = this.handleChangeFinancialInfo.bind(this);
        this.doSaveProfile = this.doSaveProfile.bind(this); 
        this.handleDone = this.handleDone.bind(this);
        this.handleMfaConfirmed = this.handleMfaConfirmed.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleMfaConfirmed = this.handleMfaConfirmed.bind(this);
        this.handleOptInConfirmed = this.handleOptInConfirmed.bind(this);
        this.loadData = this.loadData.bind(this);
        this.scrollToTop = this.scrollToTop.bind(this);
      }

   async handleBack() {
        switch (this.state.formState) {
          case this.STATE_EDIT_ADDRESS:
            this.setState({ formState: this.STATE_VIEW });
            break;
          case this.STATE_EDIT_FINANCIAL_INFO: {
            this.setState({ formState: this.STATE_VIEW });
            await this.loadData();
            break;
          }
          case this.STATE_MFA_CONFIRM:
          case this.STATE_VALIDATE_MOBILE:
            this.setState({
              formState: this.STATE_EDIT_ADDRESS,
              isLoading: false,
            });
            break;
          default:
            break;
        }
    }

    componentDidMount() {
        this.setState({ isLoading: true });
        this.loadData();
        // if(SessionService.isEmptySession()){
        // }
    }
    componentDidUpdate(prevProps, prevState, snapshot){
        if((prevState.isLoading !== this.state.isLoading && this.state.isLoading === true)
            || prevState.formState !== this.state.formState){
            this.scrollToTop();
        }
    }

    loadData() {
        let { loadProfile } = this.props.actions;
        this.setState({ isLoading: true });
        return loadProfile().finally(() => this.setState({ isLoading: false }));
    }

    handleChangePassword(){
        history.push("change-password");
    }

    handleDone() {
        switch (this.state.formState) {
            case this.STATE_EDIT_ADDRESS:
                if(this.props.profile.saveMobile === true){
                    this.setState({formState : this.STATE_MFA_CONFIRM})
                }
                else{
                    this.setState({isLoading : true});
                    this.doSaveProfile()
                        //.then(this.setState({isLoading:false}));
                }
                break;
            case this.STATE_EDIT_FINANCIAL_INFO:
                this.setState({ isLoading: true });
                this.doSaveProfile()
                    // .then(this.setState({ isLoading: false }));
                break;
            case this.STATE_PROFILE_SAVED:

                this.loadData()
                    .then(this.setState({ formState: this.STATE_VIEW }));
                break; 
            default: 
                break;
        }
    }
    

    doSaveProfile(){
      this.scrollToTop();
      const {
        userId, 
        userHash,
        firstName,
        lastName,
        selectedLanguage,
        bankruptcyFlag,
        mobileOptIn,
        suspendedFlag,
        email,
        mobilePhone,
        address1,
        address2,
        city,
        state,
        postalCode,
        source,
        tokenId,
        optInToken,
        saveMobile,
        saveAddress,
        mobilePhoneId,
        addressId,
        years,
        months,
        rentOrOwn,
        monthlyResidencePayment,
        residenceType,
        accountID,
      } = this.props.profile;
      const {employers,incomes} = SessionService.getSession()
      this.setState({isLoading: true});
        return this.props.actions.saveExtendedProfile({
            userId, 
            userHash,
            firstName,
            lastName,
            selectedLanguage,
            bankruptcyFlag,
            suspendedFlag,
            mobileOptIn,
            email,
            mobilePhone,
            address1,
            address2,
            city,
            state,
            postalCode,
            source,
            tokenId,
            optInToken,
            saveMobile,
            saveAddress,
            mobilePhoneId,
            addressId,
            ownResidence : rentOrOwn ? rentOrOwn > 0 ? true : false : false,
            residenceType,
            monthlyResidencePayment : monthlyResidencePayment || 0,
            employers : employers ? employers.map(emp=> {
                return {
                    ...emp,
                    employerName: !emp.employerName && emp.primaryIncomeSource ==
                    FinancialService.PRIMARY_INCOME_SOURCE_SELFEMPLOYED ? metadataService.getLookupText("incomeSource",emp.primaryIncomeSource)
                    : emp.employerName,
                    id : emp.isAdd ? 0 : emp.id
                }
            }) : [],
            incomes : incomes ? incomes.map(inc=> {
                return {
                    ...inc,
                    incomeSource : Number(inc.otherIncomeSource),
                    id : inc.isAdd ? 0 : inc.id,
                    payFrequency : inc.payFrequency || FinancialService.PAY_FREQUENCY_MONTHLY                   
                }
            }) : [],
            months: months || 0,
            years : years || 0,
            accountID
        })
        .then(e => {
            this.props.actions.setAppLanguage(selectedLanguage);
            this.setState({isLoading: false, formState : this.STATE_PROFILE_SAVED})
        });
    }
   
    handleRequestEditProfile(){
        this.setState({formState : this.STATE_EDIT_ADDRESS});
    }
    handleRequestEditFinancialInfo() {
        this.setState({ formState: this.STATE_EDIT_FINANCIAL_INFO });
    }
    handleMfaConfirmed(mfaToken){
      const mfaConfirmedProfile = this.props.profile; 
      mfaConfirmedProfile.tokenId = mfaToken; 
      this.props.actions.editProfile(mfaConfirmedProfile);
      this.setState({formState : this.STATE_VALIDATE_MOBILE});
    }
    handleOptInConfirmed(mfaToken){
      const optInConfirmedProfile = this.props.profile; 
      optInConfirmedProfile.optInToken = mfaToken; 
      this.props.actions.editProfile(optInConfirmedProfile);
      this.doSaveProfile(); 
    }

    handleChangeProfile(editedProfile){
        editedProfile.saveAddress = (this.props.originalProfile.address1 !== editedProfile.address1 || this.props.originalProfile.address2 !== editedProfile.address2 
            || this.props.originalProfile.state !== editedProfile.state || this.props.originalProfile.city !== editedProfile.city || this.props.originalProfile.postalCode !== editedProfile.postalCode
            || this.props.originalProfile.years !== editedProfile.years || this.props.originalProfile.months !== editedProfile.months
            || this.props.originalProfile.residenceType !== editedProfile.residenceType 
            || this.props.originalProfile.monthlyResidencePayment !== editedProfile.monthlyResidencePayment
            || this.props.originalProfile.selectedLanguage !== editedProfile.selectedLanguage)
      
        this.props.actions.editProfile(editedProfile);

        const isValid = !validator.isEmpty(editedProfile.address1 + "") && !validator.isEmpty(editedProfile.state + "")
            && !validator.isEmpty(editedProfile.city + "") && validator.isPostalCode(editedProfile.postalCode + "", "US")
            && !validator.isEmpty(editedProfile.years + "") && !validator.isEmpty(editedProfile.months + "")
            && !validator.isEmpty(editedProfile.monthlyResidencePayment + "")

        this.setState({ canGoNext: editedProfile.saveAddress && isValid });
    }

    handleChangeFinancialInfo(editedFinancialInfo) {
        this.props.actions.editFinancialInfo(editedFinancialInfo);
        this.setState({ canGoNext: !editedFinancialInfo.hasError });
    }
    scrollToTop(){ 
        scrollToTop();
    }

    render() {
        const {financialInfoFormOpen} = this.props
        return (
            <div>
              
                <div id="backBtnContainer" hidden >
                    <SlButton name='Back' onClick={() => this.handleBack()}/>
                </div>
                <SlPageTitle pageName='MyProfile'/>
                <SlBusyIndicator visible={this.state.isLoading}/>
                
                {this.state.formState===this.STATE_VIEW && (
                    <ViewProfile
                        onRequestEdit={this.handleRequestEditProfile}
                        onRequestEditFinancialInfo={this.handleRequestEditFinancialInfo} />
                )}
                {this.state.formState===this.STATE_EDIT_ADDRESS && (
                    <EditProfileInfo profile={this.props.profile} onChange={ this.handleChangeProfile}/>
                )}
                {this.state.formState === this.STATE_EDIT_FINANCIAL_INFO && (
                    <FinancialInfo displayNextBackButtons={false} />
                )}
                {this.state.formState===this.STATE_MFA_CONFIRM && (
                    <MfaValidation mfaConfirmed={this.handleMfaConfirmed} mode='email' mfaReason={AccountAPI.MFA_REASON_EDIT_PROFILE} language={userService.getUserLanguage()}/>
                )}
                {this.state.formState === this.STATE_VALIDATE_MOBILE && (
                    <MfaValidation mfaConfirmed={this.handleOptInConfirmed} mode='optin' mfaReason={AccountAPI.MFA_REASON_VALIDATE_USER} mobileNumber={this.props.profile.mobilePhone}/>
                )}
                {this.state.formState === this.STATE_PROFILE_SAVED && (
                  <ProfileChange/>
                )}
                {/* <ProfileInfo /> */}
                <div className='text-center'>
                {this.state.formState !== this.STATE_VIEW && this.state.formState !== this.STATE_PROFILE_SAVED && financialInfoFormOpen!==true &&(
                  <SlButton name="Back" cssClass='mr-2' onClick={() => this.handleBack()} visible={this.state.canGoBack}/>
                )}
                {this.state.formState === this.STATE_VIEW && (
                <SlButton name='ChangePassword' onClick={() => this.handleChangePassword()}/>)}
                    {(this.state.formState === this.STATE_EDIT_ADDRESS || this.state.formState === this.STATE_EDIT_FINANCIAL_INFO || this.state.formState === this.STATE_PROFILE_SAVED) && (financialInfoFormOpen!==true) && (
                <SlButton name='Done' cssClass='ml-2' onClick={() => this.handleDone()} disabled={!this.state.canGoNext || this.state.isLoading}/>)}
                </div>
                {/* <ProfileChange /> */}
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        profile: state.profile.userProfile,
        originalProfile: state.profile.originalProfile,
        financialInfo: state.profile.financialInfo,
        originalFinancialInfo: state.profile.originalFinancialInfo,
        financialInfoFormOpen : state.financialInfo.financialInfoFormOpen,
        language : state.users.language,
    }
  }
  

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            loadProfile: bindActionCreators(profileActions.loadProfile, dispatch),
            editProfile: bindActionCreators(profileActions.editProfile, dispatch),
            saveExtendedProfile: bindActionCreators(profileActions.saveExtendedUserProfile, dispatch),
            saveFinancialInfo: bindActionCreators(financialInfoActions.saveFinancialInfo, dispatch),
            editFinancialInfo: bindActionCreators(financialInfoActions.editFinancialInfo, dispatch),
            setAppLanguage: bindActionCreators(userActions.setAppLanguage, dispatch),
        }
    }
}
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyProfile);